import * as enums from "../enumerations";

/**
 * Gibt den ViewMode anhand eines Strings zurück.
 * @param viewMode
 */
export function getViewModeFromString(viewMode: string): enums.CalendarViewMode
{
    switch (viewMode)
    {
        case "month":
            return enums.CalendarViewMode.month;
        case "week":
            return enums.CalendarViewMode.week;
        case "work_week":
            return enums.CalendarViewMode.workWeek;
        case "day":
            return enums.CalendarViewMode.day;
        case "planning":
            return enums.CalendarViewMode.planning;
    }
}

/**
  * Gibt den String eines CalendarViewModes zurück.
  * @param viewMode
  */
export function getViewModeReadableString(viewMode: enums.CalendarViewMode): string
{
    switch (viewMode)
    {
        case enums.CalendarViewMode.month:
            return "Monat";
        case enums.CalendarViewMode.week:
            return "Woche";
        case enums.CalendarViewMode.workWeek:
            return "Arbeitswoche";
        case enums.CalendarViewMode.day:
            return "Tag";
        case enums.CalendarViewMode.planning:
            return "Planungsansicht";
    }
}

/**
 * Gibt den String eines CalendarViewModes zurück.
 * @param viewMode
 */
export function getViewModeString(viewMode: enums.CalendarViewMode): string
{
    switch (viewMode)
    {
        case enums.CalendarViewMode.month:
            return "month";
        case enums.CalendarViewMode.week:
            return "week";
        case enums.CalendarViewMode.workWeek:
            return "work_week";
        case enums.CalendarViewMode.day:
            return "day";
        case enums.CalendarViewMode.planning:
            return "planning";
    }
}